import { Membership } from '@moovly/clients/lib/resources/group/group.interfaces';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store/rootStore';
import { Member } from '../types/member';
import useCurrentUser from './useCurrentUser';

const useMembers = (): {
  members: Member[];
  uniqueUserIds: string[];
  token?: string;
} => {
  const { groupsWithAdminRight } = useCurrentUser();

  const members = useSelector((state: RootState) => state.members.memberships.data?.memberships || []);
  const token = useSelector((state: RootState) => state.members.memberships.data?.token);

  const uniqueUserIds = React.useMemo(() => {
    return (members || []).reduce((result: string[], member: Membership) => {
      if (!result.includes(member.user_id)) {
        result.push(member.user_id);
      }
      return result;
    }, []);
  }, [members]);

  const tranformedMembers = React.useMemo<Member[]>(() => {
    return (members || []).map((member) => ({
      ...member,
      group: groupsWithAdminRight.find((gr) => gr.id === member.group_id),
    }));
  }, [members, groupsWithAdminRight]);
  return { members: tranformedMembers || [], uniqueUserIds, token };
};

export default useMembers;
